import React, { useEffect } from "react";
import { useOutletContext } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import UsersDataTable from "@client.components/UsersDataTable";
import SettingTabs from "./SettingTabs";
import "./Settings.scss";

const UsersManagement = () => {
  const [setTopBarTitle] = useOutletContext();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  useEffect(() => {
    setTopBarTitle(t("components.TopBar.settings"));
  }, [dispatch, setTopBarTitle, t]);

  return (
    <div className="settings page">
      <SettingTabs />
      <div className="body">
        <UsersDataTable />
      </div>
    </div>
  );
};

export default UsersManagement;
